import React from "react";
import bgConnections from "../../assets/stars-bg.jpg";

export const ImpactConnectionsSection: React.FC = () => {
  return (
    <section className="relative h-screen w-full! flex items-start justify-center lg:pt-[20%] pt-[50%]">
      <img
        alt="bgConnections"
        className="absolute inset-0 w-full h-full object-cover opacity-50"
      />
      <div className="relative z-10">
        <h2
          className="text-white text-center uppercase font-bold leading-[1.46] lg:text-3xl text-lg
         "
        >
          creamos conexiones <span className="text-white">innovadoras</span>{" "}
          para
          <br /> <span className="text-white">impactar</span> de manera
          significativa la vida
          <br /> de las personas a través de{" "}
          <span className="text-white">soluciones</span> <br /> integradas de
          comunicación que dan
          <br /> <span className="text-white">valor</span> a las marcas
        </h2>
      </div>
    </section>
  );
};
